/**
 * 商城-公共接口
 * @author： xuyd
 * @date：2024-10-01
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'

const serviceModule = context.sunflower

export default {

  /**
   * 中文转拼音
   */
  chinese2pinyin: (val) => {
    return request.get(serviceModule + "/console/pinyin/chinese2pinyin?chinese=" + encodeURIComponent(val));
  },

}
